import {AbstractStandardPanel} from "@/scenes.ui/abstract-standard-panel";
import {Keys} from "@/constants/key";

export class VerticalLongPanel extends AbstractStandardPanel {

    protected getWindowKey(): string {
        return Keys.UI_WINDOW_MIDDLE_BIG;
    }

    protected getXButtonY(): number {
        return -310;
    }

    protected getXButtonX(): number {
        return 232;
    }

    protected getTitleY(): number {
        return -282;
    }

    protected getCloseButtonX(): number {
        return 0;
    }

    protected getCloseButtonY(): number {
        return 155;
    }

    protected getWindowScaleX(): number {
        return 1.05;
    };

    protected getWindowScaleY(): number {
        return 1.08;
    };
}
